import { render, staticRenderFns } from "./TheAddRemark.vue?vue&type=template&id=6f6060b4&scoped=true&"
import script from "./TheAddRemark.vue?vue&type=script&lang=js&"
export * from "./TheAddRemark.vue?vue&type=script&lang=js&"
import style0 from "./TheAddRemark.vue?vue&type=style&index=0&id=6f6060b4&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f6060b4",
  null
  
)

export default component.exports